var React = require('react');

function IconPricingPlanDeluxe (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.889 6.5C32.025 6.5 33.114 6.952 33.918 7.754L42.245 16.082C42.6427 16.4796 42.9581 16.9517 43.1733 17.4712C43.3885 17.9908 43.4992 18.5476 43.499 19.11V30.889C43.4992 31.4514 43.3885 32.0082 43.1733 32.5278C42.9581 33.0473 42.6427 33.5194 42.245 33.917L33.918 42.245C33.114 43.048 32.025 43.5 30.889 43.5H19.111C17.975 43.5 16.885 43.049 16.082 42.246L7.754 33.917C7.3563 33.5194 7.04085 33.0473 6.82569 32.5278C6.61052 32.0082 6.49985 31.4514 6.5 30.889V19.111C6.49998 18.5486 6.61081 17.9917 6.82615 17.4721C7.04149 16.9525 7.35712 16.4805 7.755 16.083L16.082 7.755C16.885 6.952 17.975 6.501 19.111 6.501L30.889 6.5Z","stroke":"#19222A","strokeWidth":"3"}));
}

IconPricingPlanDeluxe.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = IconPricingPlanDeluxe;

IconPricingPlanDeluxe.default = IconPricingPlanDeluxe;
